import React, { useState } from 'react'

import {
  ActivityIndicator,
  Button,
  Dropdown,
  Icon,
  useMediaQueryContext,
} from '@fourthwall/components'
import { FilterIcon } from '@fourthwall/icons'

import { AnalyticsFiltersSelect } from '../AnalyticsFilterSelect/AnalyticsFiltersSelect'
import type { AnalyticsFiltersSelectProps } from '../AnalyticsFilterSelect/AnalyticsFiltersSelect.types'
import * as S from './AnalyticsFiltersButton.styled'

type AnalyticsFiltersButtonProps = AnalyticsFiltersSelectProps & {
  isActive?: boolean
}

export const AnalyticsFiltersButton = ({
  filters,
  isActive,
  onChange,
}: AnalyticsFiltersButtonProps) => {
  const media = useMediaQueryContext()
  const [isOpen, setOpen] = useState(false)

  if (!filters.length) return null

  return (
    <Dropdown
      isOpen={isOpen}
      content={<AnalyticsFiltersSelect filters={filters} onChange={onChange} />}
      position="bottom-end"
      maxWidth={500}
      onClose={() => setOpen(false)}
    >
      <S.Container>
        <Button
          leftIcon={<Icon component={FilterIcon} height={18} />}
          label="Filters"
          appearance="secondary"
          size={media.tablet ? 'medium' : 'small'}
          onClick={() => setOpen((status) => !status)}
        />
        {isActive && (
          <S.ActivityIndicatorWrapper>
            <ActivityIndicator />
          </S.ActivityIndicatorWrapper>
        )}
      </S.Container>
    </Dropdown>
  )
}
